;(function (ProductTabs, $, undefined) {

  var bindUIActions = function () {
    $('.js-tab-label').click(function(){
      var tab_id = $(this).attr('data-tab');

      $('.js-tab-label').removeClass('current');
      $('.tab-content').removeClass('current');
      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
    });
  };

  ProductTabs.init = function () {
    bindUIActions();
  };

}(window.ProductTabs = window.ProductTabs || {}, jQuery));
